"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.SubscriptionPlanTypeEnum = exports.SubscriptionPlanDurationEnum = exports.FeatureTypeEnum = exports.AllowanceActorEnum = void 0;
var AllowanceActorEnum;
(function (AllowanceActorEnum) {
    AllowanceActorEnum["SYSTEM"] = "SYSTEM";
    AllowanceActorEnum["USER"] = "USER";
})(AllowanceActorEnum || (exports.AllowanceActorEnum = AllowanceActorEnum = {}));
var FeatureTypeEnum;
(function (FeatureTypeEnum) {
    FeatureTypeEnum["REFINEMENTS"] = "Refinements";
    FeatureTypeEnum["SCANS"] = "Scans";
    FeatureTypeEnum["SEATS"] = "Seats";
})(FeatureTypeEnum || (exports.FeatureTypeEnum = FeatureTypeEnum = {}));
var SubscriptionPlanDurationEnum;
(function (SubscriptionPlanDurationEnum) {
    SubscriptionPlanDurationEnum["MONTHLY"] = "Monthly";
    SubscriptionPlanDurationEnum["YEARLY"] = "Yearly";
})(SubscriptionPlanDurationEnum || (exports.SubscriptionPlanDurationEnum = SubscriptionPlanDurationEnum = {}));
var SubscriptionPlanTypeEnum;
(function (SubscriptionPlanTypeEnum) {
    SubscriptionPlanTypeEnum["ACCOUNT"] = "Account";
    SubscriptionPlanTypeEnum["ARCHIVE"] = "Archive";
})(SubscriptionPlanTypeEnum || (exports.SubscriptionPlanTypeEnum = SubscriptionPlanTypeEnum = {}));
//# sourceMappingURL=billing.js.map